
import Vue from 'vue'
import { productInCart, cartActionEnum } from '@/types'

export default Vue.extend({
  name: 'ProductCartTile',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      cartActionEnum
    }
  },
  methods: {
    adjustQty(action: string, product: productInCart) {
      this.$store.commit('adjustQty', { action, product })
    }
  }
})
